export default __webpack_public_path__ + "static/19-mohawk-skull-71429b98405bde2df5bd47c1ee899697.png";